<!-- 由 suu 创建于 2021-08-20 星期五 -->
<template>
  <div class="course-history">
    <div class="top-tab">
      <div
        class="t-item"
        :class="{ 't-item-ac': curTab == 0 }"
        @click="curTab = 0"
      >
        全部
      </div>
      <div
        class="t-item"
        :class="{ 't-item-ac': curTab == 1 }"
        @click="curTab = 1"
      >
        待评价({{ evaNum > 99 ? '99+' : evaNum }})
      </div>
      <div
        class="t-item"
        :class="{ 't-item-ac': curTab == 2 }"
        @click="curTab = 2"
      >
        已评价
      </div>
    </div>
    <div class="ch-list">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div class="l-item" v-for="(item, index) in showList" :key="index">
          <template v-if="item.data.length">
            <div class="i-title">{{ item.date }}</div>
            <div class="i-course">
              <div class="c-item" v-for="(c, ci) in item.data" :key="ci">
                <div class="ci-top">
                  <img :src="c.coachImg" class="t-img" alt="" />
                  <div class="t-desc">
                    <div class="d-time">{{ c.time }}</div>
                    <div class="d-name text-overflow">
                      {{ c.coachName }}<span>{{ c.shopName }}</span>
                    </div>
                  </div>
                  <div class="r-btn user-btn" v-if="!c.comment">评价</div>
                  <div class="r-btn-on" v-else>
                    <div class="on-text">已评价</div>
                    <van-rate
                      class="on-rate"
                      v-model="c.comment * 1"
                      allow-half
                      size="12"
                      void-icon="star"
                      color="#f7b500"
                      void-color="#ddd"
                    />
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </van-list>
    </div>
  </div>
</template>

<script>
export default {
  name: 'course-history',

  components: {},

  props: {},

  data() {
    return {
      finished: false, // 上拉加载异步请求全部加装完
      loading: false, // 拉加载异步请求是否正在进行
      curTab: 0, // 上方当前tab
      evaNum: 991, // 待评价数
      list: [
        {
          date: 2021.05,
          data: [
            {
              coachImg:
                'https://wegymer-coach.oss-cn-beijing.aliyuncs.com/5d103a74d25c6.jpg',
              coachName: '钟铁林',
              time: '05.06  18:00-19:00',
              shopName: '马厂龙湾私教馆',
              comment: '3',
              pid: '1233'
            },
            {
              coachImg:
                'https://wegymer-coach.oss-cn-beijing.aliyuncs.com/5d103a74d25c6.jpg',
              coachName: '钟铁林',
              time: '05.06  18:00-19:00',
              shopName: '马厂龙湾私教馆',
              comment: 4.5,
              pid: ''
            },
            {
              coachImg:
                'https://wegymer-coach.oss-cn-beijing.aliyuncs.com/5d103a74d25c6.jpg',
              coachName: '钟铁林',
              time: '05.06  18:00-19:00',
              shopName: '马厂龙湾私教馆',
              comment: 4.5,
              pid: ''
            }
          ]
        },
        {
          date: 2021.04,
          data: [
            {
              coachImg:
                'https://wegymer-coach.oss-cn-beijing.aliyuncs.com/5d103a74d25c6.jpg',
              coachName: '钟铁林',
              time: '04.06  18:00-19:00',
              shopName: '马厂龙湾私教馆',
              comment: '',
              pid: '1233'
            },
            {
              coachImg:
                'https://wegymer-coach.oss-cn-beijing.aliyuncs.com/5d103a74d25c6.jpg',
              coachName: '钟铁林',
              time: '04.06  18:00-19:00',
              shopName: '马厂龙湾私教馆',
              comment: 3.5,
              pid: ''
            },
            {
              coachImg:
                'https://wegymer-coach.oss-cn-beijing.aliyuncs.com/5d103a74d25c6.jpg',
              coachName: '钟铁林',
              time: '04.06  18:00-19:00',
              shopName: '马厂龙湾私教馆',
              comment: 4.5,
              pid: ''
            }
          ]
        }
      ]
    }
  },

  computed: {
    // 过滤列表
    showList() {
      let list = JSON.parse(JSON.stringify(this.list))
      if (this.curTab == 0) {
        return list
      } else {
        let newList = []
        list.forEach((v, index) => {
          newList[index] = v
          newList[index].data = v.data.filter((m) => {
            return this.curTab == 1 ? !m.comment : m.comment
          })
        })
        return newList
      }
    }
  },

  watch: {},

  created() {},

  mounted() {},

  destroyed() {},

  methods: {
    // 上拉加载
    onLoad() {
      // 异步更新数据
      // setTimeout 仅做示例，真实场景中一般为 ajax 请求
      setTimeout(() => {
        // 加载状态结束
        this.loading = false
        // 数据全部加载完成
        if (this.list.length >= 2) {
          this.finished = true
        }
      }, 1000)
    },
    getInfo() {
      this.$toast.loading('加载中')
      this.$http
        .get(
          'member/index',
          {
            uid: this.uid,
            month: this.curDate.replace('/', '-'),
            a: 'getMemberClassInfo'
          },
          true
        )
        .then((res) => {
          if (res.data.code === 200) {
            this.activeDay = res.data.data.active_day
            this.lists = res.data.data.month_list
          }
          this.$toast.clear()
        })
        .catch((err) => {
          // MessageBox.alert('数据错误请刷新重进')
          this.$toast.clear()
        })
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.course-history {
  width: 100vw;
  min-height: 100vh;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  flex-direction: column;
  position: relative;
  background-color: #f9f9f9;
  .top-tab {
    width: 100%;
    box-sizing: border-box;
    background-color: #fff;
    height: 12vw;
    display: flex;
    align-items: center;
    padding: 0 5.9vw;
    font-size: 4vw;
    color: #000000;
    .t-item {
      position: relative;
      height: 12vw;
      display: flex;
      align-items: center;
    }
    .t-item + .t-item {
      margin-left: 5.1vw;
    }
    .t-item-ac::after {
      content: '';
      width: 4.3vw;
      height: 0.8vw;
      background-color: #f04646;
      border-radius: 0.3vw;
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
    }
  }
  .ch-list {
    width: 100%;
    box-sizing: border-box;
    margin-top: 2vw;
    padding: 0 5.3vw;
    .l-item {
      width: 100%;
      box-sizing: border-box;
      margin-top: 2.7vw;
      .i-title {
        font-size: 4vw;
        font-weight: 600;
        color: #000000;
      }
      .i-course {
        width: 100%;
        box-sizing: border-box;
        .c-item {
          width: 100%;
          box-sizing: border-box;
          background-color: #ffffff;
          border-radius: 1.6vw;
          border: solid 0.3vw #f1f1f1;
          padding: 4vw 4.5vw;
          margin-top: 2.7vw;
          .ci-top {
            width: 100%;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            .t-img {
              width: 9.6vw;
              height: 9.6vw;
              border-radius: 2.7vw;
            }
            .t-desc {
              flex: 1;
              margin-left: 4.3vw;
              margin-right: 5.1vw;
              .d-time {
                font-size: 3.2vw;
                font-weight: 600;
                color: #000;
              }
              .d-name {
                margin-top: 1.1vw;
                font-size: 3.2vw;
                font-weight: 600;
                overflow: hidden;
                width: 40vw;
                span {
                  color: rgba(0, 0, 0, 0.5);
                  font-weight: 400;
                  margin-left: 2.7vw;
                }
              }
            }
            .r-btn {
              width: 16vw;
              height: 6.4vw;
              background-color: #f04646;
              border-radius: 3.2vw;
              color: #fff;
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 3.2vw;
              font-weight: 600;
            }
            .r-btn-on {
              display: flex;
              flex-direction: column;
              align-items: center;
              .on-text {
                font-size: 3.2vw;
                color: #bcbcbc;
              }
              .on-rate {
                margin-top: 1.1vw;
              }
            }
          }
        }
      }
    }
  }
}
</style>
